(function () {
    'use strict';

    const NOTE_START = '[[BP_PARTNER]]';
    const NOTE_END = '[[/BP_PARTNER]]';

    const PARTNER_CODE_PATTERN = /^[A-Za-z0-9_-]*BP$/i;

    function cleanCode(value) {
        return String(value || '')
            .trim()
            .replace(/^\/discount\//i, '')
            .split('?')[0]
            .split('#')[0]
            .trim()
            .toUpperCase();
    }

    function removeExistingMarker(note) {
        const value = String(note || '');
        const start = value.indexOf(NOTE_START);

        if (start === -1) {
            return value.trim();
        }

        const end = value.indexOf(
            NOTE_END,
            start
        );

        if (end === -1) {
            return value
                .slice(0, start)
                .trim();
        }

        return (
            value.slice(0, start) +
            '\n' +
            value.slice(
                end + NOTE_END.length
            )
        )
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    }

    async function readCart() {
        const response = await fetch(
            '/cart.js',
            {
                credentials: 'same-origin',
                headers: {
                    Accept: 'application/json'
                },
                cache: 'no-store'
            }
        );

        if (!response.ok) {
            throw new Error(
                `Cart read failed: ${response.status}`
            );
        }

        return response.json();
    }

    async function savePartnerMarker(
        code,
        name
    ) {
        const partnerCode =
            cleanCode(code);

        const partnerName =
            String(name || '')
                .replace(/\|\|/g, ' ')
                .replace(NOTE_START, '')
                .replace(NOTE_END, '')
                .trim();

        if (
            !partnerCode ||
            !partnerName ||
            !PARTNER_CODE_PATTERN.test(
                partnerCode
            )
        ) {
            return;
        }

        const cart =
            await readCart();

        const customerNote =
            removeExistingMarker(
                cart?.note || ''
            );

        const marker =
            `${NOTE_START}` +
            `${partnerName}||` +
            `${partnerCode}||true` +
            `${NOTE_END}`;

        const finalNote =
            customerNote
                ? `${customerNote}\n\n${marker}`
                : marker;

        const response = await fetch(
            '/cart/update.js',
            {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type':
                        'application/json',
                    Accept:
                        'application/json'
                },
                body: JSON.stringify({
                    note: finalNote
                }),
                cache: 'no-store'
            }
        );

        if (!response.ok) {
            throw new Error(
                `Cart note update failed: ${response.status}`
            );
        }
    }

    window.addEventListener(
        'bestypop:store-name-ready',
        (event) => {
            const code =
                event.detail?.code || '';

            const name =
                event.detail?.name || '';

            savePartnerMarker(
                code,
                name
            ).catch((error) => {
                console.warn(
                    'Unable to save partner order marker:',
                    error
                );
            });
        }
    );
})();
